require('./contractEasyLoanTypeCErrorStep.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
// @ commons
const WizardError = require('components/commons/wizardError/wizardError');
const { catalogue, analyticsId, recordEasyLoanCBackGlobalPositionButton } = require('../analytics/contractEasyLoanTypeC.tracking');
//@utils
const { recordLinkV2 } = require('utilities/tagging');

const contractEasyLoanTypeCErrorStep = ({ phoneNumber, heading = "contractEasyTypeCLoanError-okTitle", message = "contractEasyTypeCLoanError-okMessage", immContractEasyLoan, onLeave, onComponentDidMountCallback, goToGlobalPosition }) => {
    const title = formatText(heading);
    const goBackLink = {
        label: formatText('contractEasyLoanError-goBackLinkText').toUpperCase(),
    };

    recordLinkV2(catalogue[analyticsId.CONTRACT_EASY_LOAN_WIZARD_NO_OFFER]());
    React.useEffect(() => {
        return () => {
            onLeave();
        }
    }, []);

    const handleMainButtonClick = () => {
        recordEasyLoanCBackGlobalPositionButton()
        goToGlobalPosition();
    }

    return (
        <article className="contract-easy-loan-error-step row no-gutter">
            <div className="col-xs-12">
                <WizardError
                    errorMessage={title}
                    mainButton={goBackLink}
                    tealium={catalogue[analyticsId.CONTRACT_EASY_LOAN_WIZARD_ERROR]({ data: immContractEasyLoan.get('minTae') })}
                    isSecondVersion
                    onComponentDidMountCallback={onComponentDidMountCallback}
                    onMainButtonClick={handleMainButtonClick}
                >
                    <section className="row">
                        <FormattedText injectedStrings={[ phoneNumber ]} value={message} className="contract-easy-loan-error-step__block" />
                    </section>
                </WizardError>
            </div>
        </article>
    );
};

contractEasyLoanTypeCErrorStep.propTypes = {
    phoneNumber: PropTypes.string.isRequired,
    immContractEasyLoan: PropTypes.object.isRequired,
};

module.exports = contractEasyLoanTypeCErrorStep;
